
const MarkaOptions = [
    {
        id:1,
        text:"Mercedes-Benz",
    },
    {
        id:2,
        text:"Man",
    },
    {
        id:3,
        text:"Ford",
    },
    {
        id:4,
        text:"Iveco",
    },
    {
        id:5,
        text:"Renault",
    },
    {
        id:6,
        text:"Scania",
    },
    {
        id:7,
        text:"Volvo",
    },
    {
        id:8,
        text:"Daf",
    },
    {
        id:9,
        text:"BMC",
    }
]

export default MarkaOptions